import $ from "jquery";
import slick from 'slick-carousel';

$(".testimonials-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
  infinite: true,
  cssEase: "linear",
  autoplay: false,
});

$(".single-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
  infinite: true,
  cssEase: "linear",
  autoplay: false,
});
